import React from 'react';

import  { useState, useRef, useCallback } from 'react';
import  { useEffect }from 'react';
import  { 
    useMemo,
  
    StrictMode, } from 'react';

import './BijeleStranice.css'
import './DnevnepromjeneDonat.css'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { componentStyles } from '../services/elementDesign'
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';



import Fab from '@mui/material/Fab';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField';


import Grid from '@mui/material/Unstable_Grid2';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Modal from '@mui/material/Modal';


import Loader3 from './Loader3';
import { DataGrid,
    useGridApiRef,
    DEFAULT_GRID_AUTOSIZE_OPTIONS,} from '@mui/x-data-grid';
import axios from 'axios';
import { APICall } from './services/api.service';
import { useSelector, useDispatch } from 'react-redux';
import * as actions from "./redux/actions"
import AutoModal from './AutoModal';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {statusObradeOptions, trebaLiSklonitiOptions} from './variables/variables.js';

import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import Swal from 'sweetalert2';
import { Alert } from '@mui/material';

import * as useLocalStorage from './services/useLocalStorage'
import BijeleStranice from './BijeleStranice.js';
import ZuteStranice from './ZuteStranice.js';


import ExportStatCSVNew from './ExportStatCSVNew';
import ExportOperStatCSV from './ExportOperStatCSV';

//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from "dayjs";


import { AllCommunityModule } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";


import { useSearchParams } from "react-router-dom";




import {
    ClientSideRowModelModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    ModuleRegistry,
    ValidationModule,
    createGrid,
    themeQuartz,
    themeBalham,

    RowSelectionModule,
    RowApiModule,
    RowStyleModule,
    TextEditorModule


} from "ag-grid-community";




import { styled } from "@mui/material/styles";


const MyTextField = styled(TextField)(() => ({
  ".MuiInputBase-input.Mui-disabled": {
    WebkitTextFillColor: "black",
    color: "black"
  }
}));
  
  
ModuleRegistry.registerModules([
    RowSelectionModule,
    ClientSideRowModelModule,


    ValidationModule,
    ColumnApiModule,
    ColumnAutoSizeModule,
    RowApiModule,
    RowStyleModule,
    TextEditorModule 
    
]);
  
  
  


  const myTheme = themeBalham.withParams({
    headerHeight: "30px",
    headerTextColor: "black",
    headerBackgroundColor: "#99ABCD",
    headerCellHoverBackgroundColor: "rgba(80, 40, 140, 0.66)",
    headerCellMovingBackgroundColor: "rgb(80, 40, 140)",
    selectedRowBackgroundColor: '#8386a6',
    //fontSize: 16,
    fontWeight:400

  });

const theme = createTheme({
    palette: {
        primary: {
            main: '#520074'
        }
    },
    mixins: {
        MuiDataGrid: {
          // Pinned columns sections
          pinnedBackground: '#520074',
          // Headers, and top & bottom fixed rows
          containerBackground: 'primary',
        },
      },

});


function Statistika() {


/**************************************************OPERATORI GRID**************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const [operatoriStat, setOperatorStat] = useState(false);
const [operatoriTable, setOperatoriTable] = useState([], []);
const [selectedOperStat, setSelectedOperStat] = useState([]);

    const gridRef_Stat = useRef();
    const containerStyle_Stat = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle_Stat = useMemo(() => ({ height: "100%", width: "100%" }), []);

    const themeAG = useMemo(() => {
        return myTheme;
    }, []);

    const autoSizeStrategy_Stat = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : false
        };
      }, []);

      const autoSizeAll_Stat = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef_Stat.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef_Stat.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady_Stat = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll_Stat();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll_Stat= useCallback((event) =>{
            console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            console.log("Selected");
      }, []);

      const onColumnResized_Stat = useCallback((params) => {
        console.log(params);
      }, []);

      const themeAG_Stat = useMemo(() => {
        return myTheme;
      }, []);
    

    const onSelectionChanged = useCallback((event) => {

        
        
        let selectedData=[]
    

        
        for(var i=0; i<event.api.getSelectedNodes().length; i++) {


            selectedData.push(event.api.getSelectedNodes()[i].data);

        }
        
        
        setSelectedOperStat(selectedData);

        console.log("Selecteeeed");
        console.log(selectedData);
  

    
    
    }, []);



/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


/*****************************************************TEZINE GRID**************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const [tezineShow, setTezineShow] = useState(false);
const [tezineTable, setTezineTable] = useState([], []);
const [selectedTezine, setSelectedTezine] = useState([]);

    const gridRef_Tezine = useRef();
    const containerStyle_Tezine = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle_Tezine = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategy_Tezine = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : false
        };
      }, []);

      const autoSizeAll_Tezine = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef_Tezine.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef_Tezine.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady_Tezine = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll_Tezine();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll_Tezine= useCallback((event) =>{
            console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            console.log("Selected");
      }, []);

      const onColumnResized_Tezine = useCallback((params) => {
        console.log(params);
      }, []);

      const themeAG_Tezine = useMemo(() => {
        return myTheme;
      }, []);
    

    const onSelectionChanged_Tezine = useCallback((event) => {

        
        
        let selectedData=[]
    

        
        for(var i=0; i<event.api.getSelectedNodes().length; i++) {


            selectedData.push(event.api.getSelectedNodes()[i].data);

        }
        
        
        setSelectedTezine(selectedData);

        console.log("Selecteeeed");
        console.log(selectedData);
  

    
    
    }, []);

    const [editTezine, setEditTezine] = useState([]);
    const [enableEditTezine, setEnableEditTezine] = useState(false);

    const onCellValueChanged = ({ data }) => {
            console.log(data);

            console.log("Dosad edit tezine: ");
            console.log(editTezine);

            let editedData = editTezine;

            editedData.push({rbr_stupca: data.rbr_stupca, polje: data.polje, tezina: data.tezina});

            console.log("Changed data:");
            console.log(editedData);

            setEditTezine(editedData);

            console.log(editedData.length);
            console.log(editTezine.length);

            setEnableEditTezine(false);

            
    };





/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */


/**************************************************Referenti GRID**************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

const [selectedItemsBadData, setSelectedItemsBadData] = useState([]);

    const gridRef_Ref = useRef();
    const containerStyle_Ref = useMemo(() => ({ width: "100%", height: "100%" }), []);
    const gridStyle_Ref = useMemo(() => ({ height: "100%", width: "100%" }), []);



    const autoSizeStrategy_Ref = useMemo(() => {
        return {
          type: "fitCellContents",
          skipHeader : false
        };
      }, []);

      const autoSizeAll_Ref = useCallback((skipHeader) => {
        const allColumnIds = [];
        gridRef_Ref.current.api.getColumns().forEach((column) => {
          allColumnIds.push(column.getId());
        });
        gridRef_Ref.current.api.autoSizeColumns(allColumnIds, skipHeader);
      }, []);


      const onGridReady_Ref = useCallback((event) => {
        console.log("Grid ready *********************************************************************************")
        let nodes = event.api.getRenderedNodes();
        autoSizeAll_Ref();
        if (nodes.length) {
          //nodes[0].setSelected(true); //selects the first row in the rendered view
          //nodes[1].setSelected(true);
        }
      }, []);

      const selectAll_Ref= useCallback((event) =>{
            console.log("I wanna select it all!!!!!");

            event.api.selectAll();
            console.log("Selected");
      }, []);

      const onColumnResized_Ref = useCallback((params) => {
        console.log(params);
      }, []);

 
    

    const onSelectionChanged_Ref = useCallback((event) => {

        
        
        let selectedData=[]
    

        
        for(var i=0; i<event.api.getSelectedNodes().length; i++) {


            selectedData.push(event.api.getSelectedNodes()[i].data);

        }
        
        
        setSelectedItemsBadData(selectedData);

        console.log("Selecteeeed");
        console.log(selectedData);
  

    
    
    }, []);



/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */
/******************************************************************************************************************************** */

   

    


    
    const dispatch = useDispatch()

    const navigate = useNavigate();

    const [curr_time, setCurrTime] = useState('');

    const [seeStatAll, setSeeStatAll] = useState(false);
    


    const token = localStorage.getItem("token");


    //const { user: currentUser } = useSelector((state) => state.auth);
    const user = localStorage.getItem("user");
    const username = localStorage.getItem("username");
    const ref = localStorage.getItem("id");


    const stat = localStorage.getItem("stat");


    const togglingValue = useSelector((state) => state.togglingVariable?state.togglingVariable.value: 0);
    const isMenuOpen = useSelector(store=>store.menu?store.menu.open:false)

 

    const toastError = {                                                        
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "light",
   };

   const toastSuccess = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };

   const toastInfo = {                                                        
             position: "top-center",
             autoClose: 2000,
             hideProgressBar: false,
             closeOnClick: true,
             pauseOnHover: false,
             draggable: true,
             progress: undefined,
             theme: "light",
   };
   



useEffect(() => {
        

        console.log("Ref: ")
        console.log(ref);


        if(stat == 1 && ref!=114 && ref!=112) {
            console.log("Treba staviti na true")
            setSeeStatAll(true);

        }



        console.log("Stat is: ")
        console.log(stat)
        console.log(seeStatAll);


        let tmp = new Date();

        tmp.setMinutes(tmp.getMinutes() - 25);


        let timeNow = tmp.getDate() + "." + (tmp.getMonth() + 1) + "." + " " + tmp.getHours() + ":" + tmp.getMinutes();

        setCurrTime(timeNow);

        console.log("Getting today!!!");
        
        let td = tmp.getFullYear().toString() +
                 (tmp.getMonth() + 1).toString().padStart(2, '0') +
                 tmp.getDate().toString().padStart(2, '0');

        console.log(td);

        setToday(td);

        getOperatori ();



}, []);


useEffect(()=>{
        document.title="Statistika"
},[])


    const [showBadData, setShowBadData] = useState(false);
    const [badData, setBadData] = useState([],[]);

    const [operatori, setOperatori] = useState([]);
    const [tkcList, setTKCList] = useState([]);

    const [TKC, setTKC] = useState('');
    const [datum1, setDatum1] = useState('');
    const [datum2, setDatum2] = useState('');
    const [todayDate, setToday] = useState('');

    const [currOper, setCurrOper] = useState({val_name:'', val_username:'', val_id:null});


    const [errors, setErrors] = useState([]);

    const [currError, setCurrError] = useState({});

    const [callingCodes, setCallingCodes] = useState([]);

    const [currCallingCode, setCurrCallingCode] = useState({});

    const [checked, setChecked] = useState(false);

    const [doneCheck, setDoneCheck] = useState(0);

    const [chosenDate, setChosenDate] = useState('');
    const [chosenDate2, setChosenDate2] = useState('');

    

async function getOperatori () {


        dispatch(actions.isLoading());


        
        APICall(

            '/GetAgents',
            {

                platform: '0',
                version:'1.0',

            },
            {
                token
            }).then(


                (response) => {
                
                    dispatch(actions.isNotLoading());

                    if(response==undefined) dispatch(actions.isNotLoading());
                
                                if(response.data.list && response.data.list.length!=0){
                                        var dataTmp = response.data;

                                        console.log("/*********************************************************************/");
                                        console.log(dataTmp.list[0]);
                                        console.log("/*********************************************************************/");


                                        setOperatori(dataTmp.list)

                                        console.log(dataTmp.list);

                                        
                                        let networkCallingCode = dataTmp.list.find((it) => {
                                           
                                            if(it.val_id == ref){
                                               
                                                return it;
                                            } 
                                        });


                                        console.log(networkCallingCode);
                    
                                         
                                        //setCurrOper(networkCallingCode);

                                        setCurrOper({val_name:networkCallingCode.val_name, val_username:networkCallingCode.val_username, val_id:networkCallingCode.val_id})



                                        getTKCList();



                    
                                        
                                    }else{



                                            setOperatori([]);

                                            getTKCList();


                                    }
            
                        
                
                },

                (error) => {

                    dispatch(actions.isNotLoading());

                
                    setOperatori([]);


                
                            if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                            } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                                toastError);
                                        
                                                setTimeout(() => {
                                                    dispatch(actions.logOut());
                                                    navigate('/');
                                                }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                                toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                            }
                        
                    
                
                
                });

            
            
}  



async function getTKCList () {


    dispatch(actions.isLoading());


    
    APICall(

        '/GetTKCList',
        {

            platform: '0',
            version:'1.0',

        },
        {
            token
        }).then(


            (response) => {
            
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log("/*********************************************************************/");
                                    console.log(dataTmp.list[0]);
                                    console.log("/*********************************************************************/");


                                    setTKCList(dataTmp.list)

                                  



                
                                    
                                }else{



                                        setTKCList([])


                                }
        
                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setTKCList([]);


            
                        if(!error.response){

                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);
                        


                        } else {


                            if(!error.response.status){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                toastError);

                            }else{

                                if (error.response.status == 401) {
            
                        
                                    toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                
                            
                                } else {
                            
                            
                                            toast.error(error.response.data.message,
                                                toastError);
                                                                        
                                    
                                }
                            }
                        }
                    
                
            
            
            });

        
        
}  



async function getStats () {


    setOperatorStat(false);
    setShowBadData(false);

    setOperatoriTable([],[]);
    setBadData([],[]);

    dispatch(actions.isLoading());

    let chosenOP = '';
    let chosenOPID=null;

    let chosenTKC = '';

    let chosenD_DO = '';
    let chosenD_OD = '';

    console.log(ref)

    console.log(chosenOP);

    if(currOper && currOper.val_username && currOper.val_username!=''){

        console.log("Odabran operator");

        console.log(currOper)

        chosenOP = currOper.val_username;
        chosenOPID = currOper.val_id;

    } else {


        chosenOP = '';
        chosenOPID = null;
    }



    if(TKC && TKC.id && TKC.id!=''){

        console.log("Odabrana mreza");

        console.log(TKC)

        chosenTKC = TKC.id;

    } else {


        chosenTKC = '';
    }
    



    if(datum1 && datum1!=''){

        console.log("Datum postoji!");

        console.log(datum1);

        chosenD_OD = datum1;
    } else {


        chosenD_OD = todayDate;
    }


    if(datum2 && datum2!=''){

        console.log("Datum postoji!");

        console.log(datum2);

        chosenD_DO = datum2;
    } else {


        chosenD_DO = todayDate;
    }


    APICall(
    
        '/GetStatsAgentVal_v2',

        
        {

                platform: '0',
                version:'1.0',
                
                oper:chosenOPID,
                //oper:ref,
                tkc: chosenTKC,
                datum1: chosenD_OD,
                datum2: chosenD_DO

            },
        {
            token
        }).then(


            (response) => {
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());

                    if(response.status==200){
            
                            if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log(dataTmp.list[0]);

                                    let i = 0;

                                
                                    const keysToSum = [
                                    'AUTOK', 'RK', 'RSU', 'RDU', 'RSS',
                                    'BFI', 'BFD', 'BFU', 'BRI', 'BRD',
                                    'BRU', 'ZFI', 'ZFD', 'ZFU',
                                    'BZC', 'ZRI', 'ZRD', 'ZRU',
                                    'MATP_CHECK', 'MATPI', 'MATPD', 'MATPU', 'ACH'
                                    ];

                                    // Coerce to number safely
                                    const toNum = (v) => {
                                    const n = Number(v);
                                    return Number.isFinite(n) ? n : 0;
                                    };

                                    const groupedResult = [];

        
                                    const groupedMap = dataTmp.list.reduce((acc, item) => {
                                                const key = item.naziv; //  item.TKC, item.Referent
                                                if (!acc[key]) acc[key] = [];
                                                acc[key].push(item);
                                                return acc;
                                    }, {});

                                    Object.entries(groupedMap).forEach(([naziv, items]) => {
                                               
                                                const dates = items
                                                    .map(i => i.Datum)
                                                    .filter(Boolean)
                                                    .sort();

                                                const subtotal = {
                                                    ...items[0],          
                                                    Referent: 'Ukupno',    
                                                    Datum: `${dates[0]} - ${dates[dates.length - 1]}`
                                                };

                                                
                                                keysToSum.forEach(k => { subtotal[k] = 0; });

                                             
                                                items.forEach(row => {
                                                    keysToSum.forEach(k => {
                                                    subtotal[k] += toNum(row[k]);
                                                    });
                                                });

                                               
                                                groupedResult.push(...items, subtotal);
                                    });
                                      
                                     


                                      console.log("Reduced array:");
                                      console.log(groupedMap);
                                      console.log(dataTmp.list)
                                      console.log(groupedResult);
                                    
                                    
                                      let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                                     
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
                                      
                                
                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                flex:1,
                                                //"width": widthC

                                            
                                            }
                                        )
                                    })




                                    const isRange = (v) => typeof v === 'string' && v.includes(' - ');
                                    const parseYYYYMMDD = (s) => {
                                        if (typeof s !== 'string' || !/^\d{8}$/.test(s)) return null;
                                        const y = +s.slice(0, 4), m = +s.slice(4, 6) - 1, d = +s.slice(6, 8);
                                        return new Date(Date.UTC(y, m, d));
                                    };
                                    const fmtSingle = (s) => {
                                        const d = parseYYYYMMDD(s);
                                        return d ? d.toLocaleDateString('hr-HR', { timeZone: 'UTC' }) : (s ?? '');
                                    };
                                    const fmtMaybeRange = (v) =>
                                        isRange(v) ? v.split(' - ').map(fmtSingle).join(' - ') : fmtSingle(v);

                                    
                                    const datumColDef = {
                                        field: 'Datum',
                                        headerName: 'Datum',
                                        valueFormatter: (params) => fmtMaybeRange(params.value),
                                        
                                        comparator: (a, b) => {
                                            const num = (s) => (typeof s === 'string' && /^\d{8}$/.test(s) ? Number(s) : NaN);
                                            const na = num(a), nb = num(b);
                                            if (!Number.isNaN(na) && !Number.isNaN(nb)) return na - nb;
                                            
                                            return 0;
                                        },
                                    };

                                    
                                    const gridOptions = {
                                        columnDefs: [
                                             ...columns,
                                            datumColDef,
                                        ],
                                      
                                        postSort: (rowNodes) => {
                                            const tail = [];
                                            for (let i = rowNodes.length - 1; i >= 0; i--) {
                                            const v = rowNodes[i]?.data?.Datum;
                                            if (isRange(v)) {
                                                tail.push(rowNodes[i]);
                                                rowNodes.splice(i, 1);
                                            }
                                            }
                                            rowNodes.push(...tail);
                                        },
                                    };

                                    

                                    
                                    //let rows =dataTmp.list.map((item, index)=> {
                                    //    return({...item,id:index})
                                    //})
                                    let rows =groupedResult.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    setBadData({
                                            columns,
                                            rows
                                    })

                                    setShowBadData(true);

                                
                        

                            }else{

        

                                     toast.info("Ne postoje podaci za unesene datume i/ili referenta, molimo provjerite odabrane parametre",
                                         toastError);
                                
                

                                    setBadData([],[]);
                                   

                                

                            }
            
                    } else {

                                
                                console.log(response);

                                setBadData([],[]);

                                if(response.status == 401){

                                        toast.error(response.data.message,
                                            toastError);
                                
                                        setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                        }, 5000);   


                                } else {

                                        toast.error(response.data.message, toastError);

                                        
                                }

                    }                        
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setBadData([],[]);


            
                        if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                        } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                        }
                    
                    
            
            
            });

            
            
}      


async function getStatsOperatori () {


    setOperatorStat(false);
    setShowBadData(false);

    setOperatoriTable([],[]);
    setBadData([],[]);
   
    setTezineShow(false);
    setTezineTable([],[]);

    dispatch(actions.isLoading());

    let chosenOP = '';
    let chosenOPID = null;

    let chosenTKC = '';

    let chosenD_DO = '';
    let chosenD_OD = '';

    console.log(ref)

    console.log(chosenOP);
    console.log(currOper);

    if(currOper && currOper.val_username && currOper.val_username!=''){

        console.log("Odabran operator");

        console.log(currOper)

        chosenOP = currOper.val_username;
        chosenOPID=currOper.val_id;

    } else {


        chosenOP = '';
        chosenOPID=null;
    }



    if(TKC && TKC.id && TKC.id!=''){

        console.log("Odabrana mreza");

        console.log(TKC)

        chosenTKC = TKC.id;

    } else {


        chosenTKC = '';
    }
    



    if(datum1 && datum1!=''){

        console.log("Datum postoji!");

        console.log(datum1);

        chosenD_OD = datum1;
    } else {


        chosenD_OD = todayDate;
    }


    if(datum2 && datum2!=''){

        console.log("Datum postoji!");

        console.log(datum2);

        chosenD_DO = datum2;
    } else {


        chosenD_DO = todayDate;
    }


    APICall(
    
        '/getOperateriStat',
        
        {


                
                //oper:chosenOP,
                ref:chosenOPID,
                tkc: chosenTKC,
                datum_od: chosenD_OD,
                datum_do: chosenD_DO

            },
        {
            token
        }).then(


            (response) => {
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());
            
                if(response.status==200){
                console.log(response.data);
                if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log(dataTmp.list[0]);

                                    
                                    
                                      let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                                     
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
     
        
                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                flex: 1,
                                                //"width": widthC

                                            
                                            }
                                        )

                                    
                                    })

 
                                    
                                    
                                    let rows =dataTmp.list.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    console.log(rows);
                                    console.log(columns);
                                    

                                    setOperatoriTable({
                                            columns,
                                            rows
                                    })

                                    setOperatorStat(true);


                                  
                        

                            }else{

        

                                    // toast.info(response.data.message,
                                    //     toastError);
                                
                

                                    setOperatoriTable([],[]);

                                    setOperatorStat(false);
                                

                                

                            }
             
                } else {

                            
                            console.log(response);

                            setOperatoriTable([],[]);

                            setOperatorStat(false);

                            if(response.status == 401){

                                    toast.error(response.data.message,
                                        toastError);
                            
                                    setTimeout(() => {
                                        dispatch(actions.logOut());
                                        navigate('/');
                                    }, 5000);   


                            } else {

                                    toast.error(response.data.message, toastError);

                                    
                            }

                }                    
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

            
                setOperatoriTable([],[]);
                setOperatorStat(false);


            
                        if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                        } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                        }
                    
                    
            
            
            });

            
            
}      

async function getStatsTezine () {



    setTezineTable([],[]);
    setTezineShow(false);
   


    dispatch(actions.isLoading());


    APICall(
    
        '/getStatTezine',
        
        {


            },
        {
            token
        }).then(


            (response) => {
                
                dispatch(actions.isNotLoading());

                if(response==undefined) dispatch(actions.isNotLoading());

                if(response.status==200){
            
               
                console.log(response.data);

                if(response.data.list && response.data.list.length!=0){
                                    var dataTmp = response.data;

                                    console.log(dataTmp.list[0]);

                                    
                                    
                                      let columns= Object.getOwnPropertyNames(dataTmp.list[0]).map((column,index)=>{
                                     
                                        var a = column.charAt(0).toUpperCase() + column.slice(1);
     
        
                                        
                                        return(
                                            {
                                                "field": column,
                                                "getRowId": index,
                                                flex: 1,
                                                

                                            
                                            }
                                        )

                                    
                                    })

                                    
                                    let rows =dataTmp.list.map((item, index)=> {
                                        return({...item,id:index})
                                    })

                                    console.log(rows);
                                    console.log(columns);
                                    

                                    const updatedColumns = columns.map((col) => {
                    

                                        if(col.field == "tezina"){
                                            return {
                                                field: col.field,
                                                editable: seeStatAll
                                                
                                            }
                                     
                            
                                        } else {
            
                                            return {
                                                ...col
                                                
                                            }
                                        }
                        
                        
                                        //return col;
                                    });
                    
                    
                                    columns = updatedColumns;

                                    setTezineTable({
                                            columns,
                                            rows
                                    })

                                    setTezineShow(true);


                                  
                        

                            }else{

        

                                     toast.info("Došlo je do problema pri dohvaćanju podataka sa servera, molimo pokušajte kasnije",
                                         toastError);
                                
                

                                    setTezineTable([],[]);

                                    setTezineShow(false);
                                

                                

                            }
             
                    } else {

                                
                                console.log(response);

                                setTezineTable([],[]);
                                setTezineShow(false);

                                if(response.status == 401){

                                        toast.error(response.data.message,
                                            toastError);
                                
                                        setTimeout(() => {
                                            dispatch(actions.logOut());
                                            navigate('/');
                                        }, 5000);   


                                } else {

                                        toast.error(response.data.message, toastError);

                                        getStatsTezine();
                                }

                    }                   
            
            },

            (error) => {

                dispatch(actions.isNotLoading());

                        setTezineTable([],[]);

                        setTezineShow(false);


            
                        if(!error.response){

                                toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);
                            


                        } else {


                                if(!error.response.status){

                                    toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                    toastError);

                                }else{

                                    if (error.response.status == 401) {
                
                            
                                        toast.error(error.response.data.message,
                                            toastError);
                                    
                                            setTimeout(() => {
                                                dispatch(actions.logOut());
                                                navigate('/');
                                            }, 5000);   

                                    
                                
                                    } else {
                                
                                
                                            toast.error(error.response.data.message,
                                                    toastError);
                                                                            
                                        
                                    }
                                }
                        }
                    
                    
            
            
            });

            
            
}     


async function updateStatsTezine () {


    console.log(editTezine);



    dispatch(actions.isLoading());

    let arrayString = '';

    let i = 0;

    editTezine.map((item)=>{
        if(i==0){
            arrayString = item.polje + '=' + item.tezina;
            i++;
        }else{
            arrayString = arrayString + '; ' + item.polje + '=' + item.tezina; 
        }
    });
    console.log(arrayString);

            Swal.fire({
                customClass: {
                    container: 'my-swal'
                    },
                title: "Jeste li sigurni da želite promijeniti težine za sva ova polja? " + arrayString,
           
                showCancelButton: true,
                showConfirmButton:true,
                confirmButtonText: "Promijeni",
            
                cancelButtonText: 'Odustani'
                }).then((result) => {
                if (result.isConfirmed) {
    
    
                            APICall(
                            
                                '/updateStatTezineArr',
                                
                                {
                                    editTezine: editTezine

                                    },
                                {
                                    token
                                }).then(


                                    (response) => {
                                        
                                        dispatch(actions.isNotLoading());

                                        if(response==undefined) dispatch(actions.isNotLoading());
                                    
                                    
                                        console.log(response.data);

                                        if(response.status == 200){
                                                            

                                                            toast.success(response.data.message, toastSuccess);

                                                            getStatsTezine();

                                                            setEditTezine([]);


                                                        
                                                

                                        } else {

                                                    
                                                    console.log(response);

                                                    setTezineTable([],[]);
                                                    setTezineShow(false);

                                                    setEditTezine([]);

                                                    if(response.status == 401){

                                                            toast.error(response.data.message,
                                                                toastError);
                                                    
                                                            setTimeout(() => {
                                                                dispatch(actions.logOut());
                                                                navigate('/');
                                                            }, 5000);   


                                                    } else {

                                                            toast.error(response.data.message, toastError);

                                                            getStatsTezine();

                                                            
                                                    }

                                        }

                                    
                                            
                                    
                                    },

                                    (error) => {

                                        dispatch(actions.isNotLoading());

                                                setTezineTable([],[]);

                                                setTezineShow(false);

                                                setEditTezine([]);


                                    
                                                if(!error.response){

                                                        toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                            toastError);

                                                        getStatsTezine();
                                                    


                                                } else {


                                                        if(!error.response.status){

                                                            toast.error("Problem u povezivanju sa serverom, molimo pokušajte kasnije",
                                                            toastError);

                                                            getStatsTezine();

                                                        }else{

                                                            if (error.response.status == 401) {
                                        
                                                    
                                                                toast.error(error.response.data.message,
                                                                    toastError);
                                                            
                                                                    setTimeout(() => {
                                                                        dispatch(actions.logOut());
                                                                        navigate('/');
                                                                    }, 5000);   

                                                            
                                                        
                                                            } else {
                                                        
                                                        
                                                                    toast.error(error.response.data.message,
                                                                            toastError);
                                                                    
                                                                    getStatsTezine();
                                                                                                    
                                                                
                                                            }
                                                        }
                                                }
                                            
                                            
                                    
                                    
                                    });
           
    
                    
            
                    
                }else if(result.isDismissed){
                    console.log('Odusataoooooo');

                    setEditTezine([]);
                    setEnableEditTezine(false);

                    getStatsTezine();
                }
                });  
    
    
    

            
            
}    

const customLocaleText = {
    // Filter panel
    filterPanelAddFilter: 'Dodajte filter',
    filterPanelDeleteIconLabel: 'Ukloniti',
    filterPanelOperators: 'Operatori',
    filterPanelOperatorAnd: 'I',
    filterPanelOperatorOr: 'Ili',
    filterPanelColumns: 'Stupci',
    filterPanelInputLabel: 'Spremi',
  
    // Toolbar
    toolbarColumns: 'Stupci',
    toolbarFilters: 'Filteri',
    toolbarDensity: 'Gustoća',
    toolbarExport: 'Eksport',
    
    // Column menu
    columnMenuSortAsc: 'Uzlazno sortiranje',
    columnMenuSortDesc: 'Silazno sortiranje',
    columnMenuFilter: 'Filtrirati',
    columnMenuHideColumn: 'Sakrij stupac',
    columnMenuUnsort: 'Ukloni sortiranje',

    toolbarQuickFilterPlaceholder: 'Traži...',
    toolbarQuickFilterLabel: 'Traži',
    toolbarQuickFilterDeleteIconLabel: 'Očisti',
      // Filter operators text
  filterOperatorContains: 'sadrži',
  filterOperatorDoesNotContain: 'ne sadrži',
  filterOperatorEquals: 'jednako',
  filterOperatorDoesNotEqual: 'nije jednako',
  filterOperatorStartsWith: 'počinje s',
  filterOperatorEndsWith: 'završava s',
  filterOperatorIs: 'je',
  filterOperatorNot: 'nije',
  filterOperatorAfter: 'je iza',
  filterOperatorOnOrAfter: 'je na ili iza',
  filterOperatorBefore: 'je prije',
  filterOperatorOnOrBefore: 'je na ili prije',
  filterOperatorIsEmpty: 'je prazno',
  filterOperatorIsNotEmpty: 'nije prazno',
  filterOperatorIsAnyOf: 'je među',
  'filterOperator=': '=',
  'filterOperator!=': '!=',
  'filterOperator>': '>',
  'filterOperator>=': '>=',
  'filterOperator<': '<',
  'filterOperator<=': '<=',

    // Column menu text
    columnMenuLabel: 'Izbornik',
    columnMenuShowColumns: 'Pokaži stupce',
    columnMenuManageColumns: 'Uredi stupce',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Sakrij stupac',
    columnMenuUnsort: 'Ukloni sortiranje',
    columnMenuSortAsc: 'Sortiraj uzlazno',
    columnMenuSortDesc: 'Sortiraj silazno',

      // Columns management text
  columnsManagementSearchTitle: 'Traži',
  columnsManagementNoColumns: 'Nema stupaca',
  columnsManagementShowHideAllText: 'Prikaži/sakrij sve',
  columnsManagementReset: 'Resetiraj',

      // Checkbox selection text
  checkboxSelectionHeaderName: 'Odabir redaka',
  checkboxSelectionSelectAllRows: 'Odaberi sve retke',
  checkboxSelectionUnselectAllRows: 'Ukloni odabir',
  checkboxSelectionSelectRow: 'Odaberi redak',
  checkboxSelectionUnselectRow: 'Ukloni odabir retka',
  
    // Rows
    footerRowSelected: (count) => `${count} redaka odabrano`,
    noRowsLabel: 'Nije odabran nijedan redak',
  };

  const myEventHandler = (e) => {
    console.log("Opened contexxxxxxxt");
    console.log("yaaay");
}



const apiRef = useGridApiRef();

return (
    <ThemeProvider theme={theme}>



        <div className="DPDonat-main-container">
        <div className={`DPDonat-header ${isMenuOpen ? "is-extended": ""}`}            
                onMouseEnter={()=> dispatch(actions.openMenu())}
                onMouseLeave={()=> dispatch(actions.closeMenu())}
            >

                <div className="DPDonat-header-changes-title">

                    <Typography className="DPDonat-header-changes-title-text" variant="h5">
                        Val - Statistika djelatnika
                    </Typography>

                </div>

            </div>
            <div className="DPDonat-body">
                <div className="BadData-data-display">

                <Grid container spacing={2}>



                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="primary" 
                                        onClick={() => {
                                            
                                            //setShowBadData(true);

                                            getStats();
                                        }}
                                 
                                        >
                                        Statistika po referentima
                                    </Button>
                        </Grid>
                       
 

                        <Grid item xs={3}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="secondary" 
                                    //disabled
                                        onClick={() => {
                                            
                                            

                                            getStatsTezine();
                                        }}
                                 
                                        >
                                        Prikaži tablicu težina
                                    </Button>
                        </Grid>



     
                        {showBadData && badData.rows && <Grid item xs={2}>
                            <ExportStatCSVNew data={badData.rows} 
                            oper={''} chosenDate={''} err={currError} />
                        </Grid>}              
  
                        
                </Grid>
                <Grid container spacing={2}>


                        <Grid item xs={3}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="success" 
                                    //disabled
                                        onClick={() => {
                                            
                                            

                                            getStatsOperatori();
                                        }}
                                 
                                        >
                                        Statistika po operatorima
                                    </Button>
                        </Grid>


                        {operatoriStat && operatoriTable.rows && <Grid item xs={2}>
                            <ExportOperStatCSV data={operatoriTable.rows} 
                            oper={currOper?currOper:null} chosenDate={datum1 + '-' + datum2} err={''} 
                            />
                        </Grid>}



                </Grid>
                <Grid container spacing={2}>

                        <Grid item xs={2}>
                                     <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" disabled={!(showBadData||operatoriStat|tezineShow)}
                                        onClick={() => {

                                    
                                                setOperatorStat(false);
                                                setShowBadData(false);
                                                setTezineShow(false);

                                                setOperatoriTable([],[]);
                                                setBadData([],[]);
                                                setTezineTable([],[]);
                                            

                                          

                                        }}
                                 
                                        >
                                        Kraj
                                    </Button>
                        </Grid>

                </Grid>



                <Grid container spacing={2} sx={{marginTop:'20px', marginBottom: '20px'}}>

    

                        <Grid item xs={3}>
                 
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Djelatnik</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={currOper.val_username}
                                label="Djelatnik"
                                disabled={!seeStatAll}

                                
                                onChange={(event) => {
                                    
                                    

                                    console.log(event.target.value);

                                    console.log("CHOSEN OPERATOR!!!");

                                    console.log(event.target.value)



                                    if(event.target.value == ''){

                                           console.log("No value!!!!");

                                            let networkCallingCode = {val_username:'',val_name:'', val_id:null};

                                            setCurrOper(networkCallingCode);

                                           

                                            //getBadData(networkCallingCode, currError, currCallingCode, doneCheck, chosenDate);



                                    } else {


                                        console.log("Chosen value!!!");
                                            let chosenOP = event.target.value;
                                            

                                            let networkCallingCode = operatori.find((it) => it.val_username == chosenOP);

                                            console.log(networkCallingCode);
               
                                            setCurrOper({val_username:networkCallingCode.val_username,val_name:networkCallingCode.val_name, val_id:networkCallingCode.val_id});
                                            

                                            //getBadData(networkCallingCode, currError, currCallingCode, doneCheck, chosenDate);


                                    }


                                    


                                }}
                                >
                                {operatori && operatori.map((op,index)=> {
                                    return (
                                    <MenuItem value={op.val_username} name={op.val_name}>{op.val_name}</MenuItem>
                                    

                                    )
                                })}
                                <MenuItem value={''} name={''} >Svi</MenuItem>

                                </Select>

                                </FormControl>
                       
          
                        </Grid>


 

                        <Grid item xs={3}>
                 
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">TKC</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={TKC.id}
                                label="Greška"

                                
                                onChange={(event) => {
                                    
                                    
                                    console.log(event.target.value);



                                    if(event.target.value == ''){


                                            let networkCallingCode = {naziv:'',id:''};

                                            setTKC(networkCallingCode);


                                            //getBadData(currOper, networkCallingCode, currCallingCode, doneCheck, chosenDate);



                                    } else {


                                            let chosenOP = event.target.value;
                                            

                                            let networkCallingCode = tkcList.find((it) => it.id === chosenOP);
                    
                    
                    
                                            setTKC(networkCallingCode);
                                            

                                            //getBadData(currOper, networkCallingCode, currCallingCode, doneCheck, chosenDate);


                                    }


                                    


                                }}
                                >
                                {tkcList && tkcList.map((op,index)=> {
                                    return (
                                        <MenuItem value={op.id} name={op.naziv} >{op.naziv}</MenuItem>

                                    )
                                })}
                                <MenuItem value={''} name={''} >Sve</MenuItem>
                             

                                </Select>

                                </FormControl>
                       
          
                        </Grid>
         

                        <Grid item xs={2} sx={{marginLeft: '60px'}}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
           
        
                                <DatePicker
                                    label="Datum od"
                                    disableFuture 
                                    slotProps={{ field: { clearable: true } }}
                                    minDate={dayjs('2025-02-04')}
                                    format={'DD.MM.YYYY'}
                                    //value={chosenDate}
                                    inputFormat="dd/MM/yyyy"
                                    onChange={(newValue) => {
                                        console.log("Chosen date:");
                                        console.log(newValue);

                                        let chosen = '';

                                        let d_od = '';
                                        
                                        if(newValue && newValue.toDate()){

                                                console.log(newValue.toDate());
                                                console.log(newValue.toDate().getMonth()+1);
                                                console.log(newValue.toDate().getFullYear());
                                                console.log(newValue.toDate().getDate());

                                                //let month = newValue.toDate().getMonth()+1;
                                                let month = ("0" + (newValue.toDate().getMonth() + 1)).slice(-2)
                                                let days = ("0" + newValue.toDate().getDate()).slice(-2);
                                                chosen = days + '.' + month + '.' + newValue.toDate().getFullYear();

                                                d_od = newValue.toDate().getFullYear().toString() +
                                                (newValue.toDate().getMonth() + 1).toString().padStart(2, '0') +
                                                newValue.toDate().getDate().toString().padStart(2, '0');

                                                console.log("Settting alll daaaaaaateeeeees");
                                                console.log(d_od);



                                        }


                                        setChosenDate(chosen);
                                        setDatum1(d_od);
                                    
                                        //getBadData(currOper, currError, currCallingCode, doneCheck, chosen);
                                        
                                    }}
                                />
                            </LocalizationProvider>    
                        </Grid>
  
                        <Grid item xs={2}>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
           
        
                                <DatePicker
                                    label="Datum do"
                                    disableFuture 
                                    slotProps={{ field: { clearable: true } }}
                                    minDate={dayjs('2025-02-04')}
                                    format={'DD.MM.YYYY'}
                                    //value={chosenDate}
                                    inputFormat="dd/MM/yyyy"
                                    onChange={(newValue) => {
                                        console.log("Chosen date:");
                                        console.log(newValue);

                                        let chosen = '';

                                        let d_do = '';
                                        
                                        if(newValue && newValue.toDate()){

                                                console.log(newValue.toDate());
                                                console.log(newValue.toDate().getMonth()+1);
                                                console.log(newValue.toDate().getFullYear());
                                                console.log(newValue.toDate().getDate());

                                                //let month = newValue.toDate().getMonth()+1;
                                                let month = ("0" + (newValue.toDate().getMonth() + 1)).slice(-2)
                                                let days = ("0" + newValue.toDate().getDate()).slice(-2);
                                                chosen = days + '.' + month + '.' + newValue.toDate().getFullYear();

                                                d_do = newValue.toDate().getFullYear().toString() +
                                                (newValue.toDate().getMonth() + 1).toString().padStart(2, '0') +
                                                newValue.toDate().getDate().toString().padStart(2, '0');

                                                console.log("Settting alll daaaaaaateeeeees");
                                                console.log(d_do);



                                        }


                                        setChosenDate2(chosen);
                                        setDatum2(d_do);
                                    
                                        
                                    }}
                                />
                            </LocalizationProvider>    
                        </Grid>
                   
                </Grid>




                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: '400px', 
                        display:badData.rows? "flex":"none" }}>


                

                        
                        {badData.rows && <div style={{ width: "100%", height:"100%" , marginTop:10}}> 
                            <AgGridReact
                                rowData={badData.rows}
                                columnDefs={badData.columns}

                        

                               
                                ref={gridRef_Ref}
                                theme={themeAG}
                              
                                
                                onGridReady={onGridReady_Ref}
                                onColumnResized={onColumnResized_Ref}
                                onSelectionChanged={onSelectionChanged_Ref}
                                

                   

                                rowSelection="multiple"
                   


                        />
                        </div> }
               
                                       
                    </div>                      
                  

                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '100%', height: '270px', 
                        display:operatoriTable.rows? "flex":"none" }}>
                

                        
                        {operatoriTable.rows && <div style={{ width: "100%", height:"100%" , marginTop:10}}> 
                            <AgGridReact
                                rowData={operatoriTable.rows}
                                columnDefs={operatoriTable.columns}

                        

                               
                                ref={gridRef_Stat}
                                theme={themeAG}
                              
                                //autoSizeStrategy={autoSizeStrategy_Stat}
                                onGridReady={onGridReady_Stat}
                                onColumnResized={onColumnResized_Stat}
                                onSelectionChanged={onSelectionChanged}
                                

                   

                                rowSelection="multiple"
                   


                        />
                        </div> }
               
                                       
                    </div>  
 

                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '30px', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', height: '200px', 
                        display:tezineTable.rows? "flex":"none" }}>
                

                        
                        {tezineTable.rows && <div style={{ width: "100%", height:"100%" , marginTop:10}}> 
                            <AgGridReact
                                rowData={tezineTable.rows}
                                columnDefs={tezineTable.columns}
                                

                                ref={gridRef_Tezine}
                                theme={themeAG}
                              
                                //autoSizeStrategy={autoSizeStrategy_Stat}
                                onGridReady={onGridReady_Tezine}
                                onColumnResized={onColumnResized_Tezine}

                                onCellValueChanged={onCellValueChanged}
                 


                        />
                        </div> }
                    </div> 

                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '20px', alignItems: 'flex-start', justifyContent: 'space-between', width: '100%', 
                        display:tezineTable.rows? "flex":"none" }}> 

                        {tezineTable.rows && <Grid container xs={12} sx={{width: '500px'}}>

                                <Grid item xs={6}>
                                            <Button  sx={{height:"32px", fontSize:"10px", width:'100%'}} variant="contained" color="error" 
                                            disabled={!seeStatAll}
                                                onClick={() => {

                                            
                                                        updateStatsTezine();
                                                    

                                                

                                                }}
                                        
                                                >
                                                Spremi izmjene težina
                                            </Button>
                                </Grid>

                        </Grid>}                                       
                    </div>                    


                </div>


            </div>



        </div>
    </ThemeProvider >
  );
}

export default Statistika;